<template>
  <div class="row">
    <div class="col-12">
      <PageHeader
        has-save
        has-return
        :page="page"
        @onSave="save"
        @onReturn="back"
      />

      <ValidationObserver ref="formAddEditDiscipline" v-slot="{}" tag="form">
        <div v-if="canAddStudent">
          <SectionTitle content="Estudiante" has-line />
          <div class="px-2">
            <student-sie-search v-model="students" :limit="1" />
          </div>
        </div>
        <div class="mt-4">
          <SectionTitle content="Información General" has-line />

          <div class="row mb-4 px-2">
            <div class="col-md-4 col-sm-12 py-0">
              <span>
                <label>Fecha:</label>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="date"
                  rules="required"
                >
                  <datepicker
                    v-model="entity.disciplineDate"
                    format="dd/MMM./yyyy"
                    :max-date="maxDate"
                    :disabled="isSaved || (canAddStudent && !students.length)"
                    :error="errors[0]"
                    :custom-error-msg="'Favor seleccionar fecha'"
                    @input="onSelectedDate"
                  />
                </ValidationProvider>
              </span>
            </div>
            <div class="col-md-4 col-sm-12 py-0 mt-2 mt-md-0 mt-sm-2">
              <div class="font-weight-bold">
                Año Académico:
              </div>
              <div class="font-weight-normal">
                {{ currentYear.description }}
              </div>
            </div>
          </div>
          <div v-if="entity && entity.disciplineDate" class="row px-2">
            <div class="col-md-4 col-sm-12 py-0">
              <div v-if="currentSchool.regionId">
                <div class="font-weight-bold">
                  Región:
                </div>
                <div class="font-weight-normal">
                  {{ currentSchool.regionName }}
                </div>
              </div>
              <div v-if="!currentSchool.regionId">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="region"
                  rules="required"
                >
                  <span>
                    <custom-drop-down
                      v-model="selectedRegion"
                      :options="regions"
                      placeholder="Seleccione"
                      required
                      :fieldkey="'id'"
                      :fieldname="'name'"
                      :disabled="readonly"
                      label="Región:"
                      :error="errors[0]"
                      :custom-error-msg="messages.requiredField"
                      @input="onRegionChange($event)"
                    />
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-4 col-sm-12 py-0 mt-2 mt-md-0 mt-sm-2">
              <div v-if="currentSchool.districtId">
                <div class="font-weight-bold">
                  Distrito:
                </div>
                <div class="font-weight-normal">
                  {{ currentSchool.districtName }}
                </div>
              </div>
              <div v-if="!currentSchool.districtId">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="district"
                  rules="required"
                >
                  <span>
                    <custom-drop-down
                      v-model="selectedDistrict"
                      :options="districts"
                      placeholder="Seleccione"
                      required
                      :fieldkey="'id'"
                      :fieldname="'name'"
                      :disabled="readonly"
                      label="Distrito:"
                      :error="errors[0]"
                      :custom-error-msg="messages.requiredField"
                      @input="onDistrictChange($event)"
                    />
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="col-md-4 col-sm-12 py-0 mt-2 mt-md-0 mt-sm-2">
              <div v-if="currentSchool.schoolId">
                <div class="font-weight-bold">
                  Escuela:
                </div>
                <div class="font-weight-normal">
                  {{ currentSchool.schoolName }}
                </div>
              </div>
              <div v-if="!currentSchool.schoolId">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="school"
                  rules="required"
                >
                  <custom-drop-down
                    v-model="selectedSchool"
                    :options="schools"
                    placeholder="Seleccione"
                    required
                    :fieldkey="'id'"
                    :fieldname="'name'"
                    :disabled="readonly"
                    label="Escuela:"
                    :error="errors[0]"
                    :custom-error-msg="messages.requiredField"
                    @input="onSchoolChange($event)"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>

          <!--Row 5-->
          <div class="col-12 mt-4 pl-0 pr-0 mx-2">
            <ValidationProvider
              v-slot="{ errors }"
              name="comment"
              rules="required"
            >
              <custom-text-area
                v-model="entity.disciplineDescription"
                label="Comentario:"
                :maxlength="500"
                :disabled="readonly"
                :error="errors[0]"
                :custom-error-msg="'Favor registrar comentario.'"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="mt-3">
          <SectionTitle content="Información de Disciplina" has-line />

          <!--Row 7-->
          <div class="row px-2">
            <div class="col-md-6 col-sm-12">
              <ValidationProvider
                v-slot="{ errors }"
                name="Tipo de Remoción Disciplinaria:"
                rules="required"
              >
                <span>
                  <custom-drop-down
                    v-model="selectedAction"
                    label="Tipo de Remoción Disciplinaria:"
                    :options="disciplinaryActions"
                    placeholder="Seleccione"
                    required
                    :fieldkey="'eduespCodeId'"
                    :fieldname="'spaShortDescription'"
                    :disabled="readonly"
                    :error="errors[0]"
                    :custom-error-msg="
                      'Favor seleccionar tipo de remoción disciplinaria.'
                    "
                    @input="onDisciplinaryActionsChange($event)"
                  />
                </span>
              </ValidationProvider>

              <!--Row 8-->
              <div
                v-if="
                  selectedAction && selectedAction.eduespCodeId === code.IAES
                "
                class="col-md-12 col-sm-12 d-flex justify-content-between mt-3"
              >
                <div class="col-md-4 col-sm-12">
                  <div
                    class="custom-control custom-checkbox custom-control-inline"
                  >
                    <input
                      id="weaponFlag"
                      v-model="weaponFlag"
                      type="checkbox"
                      class="custom-control-input"
                      name="weaponFlag"
                      @change="onDisciplineFlagChange($event)"
                    />

                    <label
                      class="custom-control-label font-weight-normal font-18"
                      for="weaponFlag"
                    >
                      Arma peligrosa
                    </label>
                  </div>
                </div>
                <div class="col-md-4 col-sm-12">
                  <div
                    class="custom-control custom-checkbox custom-control-inline"
                  >
                    <input
                      id="drugsFlag"
                      v-model="drugsFlag"
                      type="checkbox"
                      class="custom-control-input"
                      name="drugsFlag"
                      @change="onDisciplineFlagChange($event)"
                    />

                    <label
                      class="custom-control-label font-weight-normal"
                      for="drugsFlag"
                    >
                      Delitos relacionados con drogas
                    </label>
                  </div>
                </div>
                <div class="col-md-4 col-sm-12">
                  <div
                    class="custom-control custom-checkbox custom-control-inline"
                  >
                    <input
                      id="bodilyInjuryFlag"
                      v-model="bodilyInjuryFlag"
                      type="checkbox"
                      class="custom-control-input"
                      name="bodilyInjuryFlag"
                      @change="onDisciplineFlagChange($event)"
                    />

                    <label
                      class="custom-control-label font-weight-normal"
                      for="bodilyInjuryFlag"
                    >
                      Lesión corporal grave
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12 mt-2 mt-md-0 mt-sm-2">
              <ValidationProvider
                v-slot="{ errors }"
                name="Duración"
                rules="required"
              >
                <span>
                  <custom-drop-down
                    v-model="selectedLength"
                    label="Duración:"
                    :options="disciplinaryLength"
                    placeholder="Seleccione"
                    required
                    :fieldkey="'eduespCodeId'"
                    :fieldname="'spaShortDescription'"
                    :disabled="readonly"
                    :error="errors[0]"
                    :custom-error-msg="'Favor seleccionar duración.'"
                    @input="onDisciplinaryLengthChange($event)"
                  />
                </span>
              </ValidationProvider>
            </div>
          </div>

          <div
            v-if="noneIsChecked"
            style="color: #ff5b5c"
            class="error-box ml-4"
          >
            <i class="fas fa-times-circle" />
            <span>Favor seleccionar una disciplina.</span>
          </div>
        </div>

        <div v-if="isSaved" class="mt-3">
          <SectionTitle content="Creación y Modificación" has-line />

          <div class="row px-2">
            <div class="col-4 py-0">
              <div class="font-weight-bold">
                Creación:
              </div>
              <div>
                <p class="font-weight-normal mb-0">
                  {{ entity.createByFullName }}
                </p>
                <p class="font-weight-normal">
                  {{ entity.createDate | date }}
                </p>
              </div>
            </div>
            <div class="col-4 py-0">
              <div class="font-weight-bold">
                Modificación:
              </div>
              <div>
                <p class="font-weight-normal mb-0">
                  {{ entity.modifyByFullName }}
                </p>
                <p class="font-weight-normal">
                  {{ entity.modifyDate | date | empty }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-3">
          <ActionButton variant="success" i="fas fa-save pr-1" @click="save()">
            Guardar
          </ActionButton>
        </div>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomDropDown from '@/components/common/CustomDropDown';
import ActionButton from '@/components/common/ActionButton';
import Datepicker from '@/components/common/CustomDatePicker';
import CustomTextArea from '@/components/common/CustomTextArea';
import StudentSieSearch from '@/components/student/StudentSieSearch.vue';
import disciplineActionsCode from '@/utils/constants/student/disciplineActionsCode';
import moment from 'moment';
import alert from '@/mixin/alert.mixin';
import store from '@/store/index';
import PageHeader from '@/components/common/page/PageHeader';
import api from '@/modules/student-discipline/api.js';
import certificationService from '@/services/api/disciplineCertification.api';
import childCountStatuses from '@/utils/constants/student/childCountStatusEnum';

export default {
  name: 'AddEditDiscipline',
  mixins: [alert],
  components: {
    PageHeader,
    SectionTitle,
    ActionButton,
    ValidationProvider,
    ValidationObserver,
    CustomDropDown,
    Datepicker,
    CustomTextArea,
    StudentSieSearch,
  },
  props: {
    discipline: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Disciplina del Estudiante',
        routes: ['Inicio', 'Estudiante', 'Disciplina'],
      },
      currentYear: {
        id: null,
        description: null,
        year: null,
      },
      currentSchool: {
        regionId: null,
        regionName: null,
        districtId: null,
        districtName: null,
        schoolId: null,
        schoolName: null,
      },
      code: disciplineActionsCode,
      isSaved: false,
      noneIsChecked: false,
      maxDate: new Date(),
      readonly: false,
      selectedRegion: null,
      selectedDistrict: null,
      selectedSchool: null,
      selectedAction: null,
      selectedLength: null,
      weaponFlag: null,
      drugsFlag: null,
      bodilyInjuryFlag: null,
      entity:
        this.discipline && this.discipline.disciplineId > 0
          ? this.formatData(this.discipline)
          : this.newDiscipline(),
      disciplinaryActions: [],
      disciplinaryLength: [],
      regions: [],
      districts: [],
      schools: [],
      messages: {
        requiredField: 'Favor seleccionar.',
      },
      certification: null,
      students: [],
    };
  },
  computed: {
    sie() {
      return this.students.length
        ? this.students[0].studentId
        : store.getters['$_student/StudentSie'];
    },
    certificationId() {
      return Number(this.$route.query?.certificationId ?? 0);
    },
    canAddStudent() {
      return this.certification?.statusId === childCountStatuses.new;
    },
  },
  mounted() {
    this.loadDisciplinaryCodesByDisciplineActions();
    this.loadDisciplinaryCodesByDisciplineLength();
    this.loadCertification();

    if (this.discipline && this.discipline.disciplineId > 0) {
      this.weaponFlag = this.discipline.weaponFlag == '1' ? true : false;
      this.drugsFlag = this.discipline.drugFlag == '1' ? true : false;
      this.bodilyInjuryFlag =
        this.discipline.bodilyInjuryFlag == '1' ? true : false;
      this.currentYear = {
        id: this.discipline.academicYearId,
        description: this.discipline.academicYearDescription,
      };
      this.currentSchool = {
        regionId: this.discipline.region_Id_Pk,
        regionName: this.discipline.region_Name,
        districtId: this.discipline.district_Id_Pk,
        districtName: this.discipline.district_Name,
        schoolId: this.discipline.locationSchool_Id_Pk,
        schoolName: this.discipline.locationSchool_Name,
      };
    }
  },
  methods: {
    back() {
      if (this.certificationId) {
        this.$router.push({
          name: 'DisciplineInformation',
          params: {
            certificationId: this.certificationId,
          },
        });
      } else this.$router.back();
    },
    async onSelectedDate() {
      const date = this.entity.disciplineDate;
      if (date) {
        await this.$ApiGet('/api/academicyears/getacademicyearfordate', {
          date: date,
        }).then(async (response) => {
          this.currentYear = {
            id: response.data.id,
            description: response.data.description,
            year: response.data.year,
          };
          this.entity.academicYearId = response.data.id;
          await this.loadStudentSchool();
          await this.loadRegions();
        });
      }
    },
    loadDisciplinaryCodesByDisciplineActions() {
      this.$ApiGet(`api/student/disciplinaryCodes/${'DiscAction'}`).then(
        (response) => {
          this.disciplinaryActions = response.data;

          if (this.entity && this.entity.disciplineId > 0) {
            this.selectedAction = {
              eduespCodeId: this.entity.discActionCode,
              spaShortDescription: this.entity.discActionDescription,
            };
          }
        }
      );
    },
    loadDisciplinaryCodesByDisciplineLength() {
      this.$ApiGet(`api/student/disciplinaryCodes/${'DiscLength'}`).then(
        (response) => {
          this.disciplinaryLength = response.data;

          if (this.entity && this.entity.disciplineId > 0) {
            this.selectedLength = {
              eduespCodeId: this.entity.discLengthCode,
              spaShortDescription: this.entity.discLengthDescription,
            };
          }
        }
      );
    },
    async loadCertification() {
      if (!this.certificationId) return;
      try {
        const { data } = await certificationService.loadCertification(
          this.certificationId
        );
        this.certification = data;
      } catch (error) {
        this.ShowToast(
          'Alerta',
          'Certificacion de Disciplina no encontrada',
          'error'
        );
      }
    },
    async loadStudentSchool() {
      await api
        .studentSchool(this.sie, this.formatDate(this.entity.disciplineDate))
        .then((response) => {
          this.currentSchool = response.data;
          this.selectedRegion = {
            id: this.currentSchool.regionId,
            name: this.currentSchool.regionName,
          };
          this.selectedDistrict = {
            id: this.currentSchool.districtId,
            name: this.currentSchool.districtName,
          };
          this.selectedSchool = {
            id: this.currentSchool.schoolId,
            name: this.currentSchool.schoolName,
          };

          if (this.entity.disciplineId === 0) {
            this.entity.academicYearId = this.currentYear.id;
            this.entity.locationSchool_Id_Pk = response.data.schoolId;
            this.entity.district_Id_Pk = response.data.districtId;
            this.entity.region_Id_Pk = response.data.regionId;
          }
        });
    },
    async loadRegions() {
      this.$ApiGet(
        `api/schools/types/regions?academicyear=${this.currentYear.id}`
      ).then((response) => {
        this.regions = response.data;
      });
    },
    loadDistricts(regionId) {
      this.$ApiGet(
        `api/schools/types/regions/districts?regionid=${regionId}&academicyear=${this.currentYear.id}`
      ).then((response) => {
        this.districts = response.data;
      });
    },
    loadSchools(districtId) {
      this.$ApiGet(
        `api/schools?districtid=${districtId}&academicyear=${this.currentYear.id}`
      ).then((response) => {
        this.schools = response.data;
      });
    },
    loadDisciplineFlag() {
      if (this.entity && this.entity.disciplineId > 0) {
        this.weaponFlag = this.entity.weaponFlag == '1' ? true : false;
        this.drugsFlag = this.entity.drugsFlag == '1' ? true : false;
        this.bodilyInjuryFlag =
          this.entity.bodilyInjuryFlag == '1' ? true : false;
      }
    },
    onRegionChange(item) {
      this.entity.region_Id_Pk = item ? item.id : null;
      this.selectedDistrict = null;
      this.selectedSchool = null;
      this.loadDistricts(this.entity.region_Id_Pk);
    },
    onDistrictChange(item) {
      this.entity.district_Id_Pk = item ? item.id : null;
      this.selectedSchool = null;
      this.loadSchools(this.entity.district_Id_Pk);
    },
    onSchoolChange(item) {
      this.entity.locationSchool_Id_Pk = item ? item.id : null;
    },
    onDisciplinaryActionsChange(item) {
      this.entity.discActionCode = item.eduespCodeId;
      this.selectedAction = {
        eduespCodeId: item.eduespCodeId,
        spaShortDescription: item.spaShortDescription,
      };
      if (this.selectedAction.eduespCodeId !== this.code.IAES) {
        this.entity.weaponFlag = '0';
        this.entity.drugFlag = '0';
        this.entity.bodilyInjuryFlag = '0';

        this.weaponFlag = false;
        this.drugsFlag = false;
        this.bodilyInjuryFlag = false;
      }
    },
    onDisciplinaryLengthChange(item) {
      this.entity.discLengthCode = item.eduespCodeId;
      this.selectedLength = {
        eduespCodeId: item.eduespCodeId,
        spaShortDescription: item.spaShortDescription,
      };
    },
    onDisciplineFlagChange(item) {
      switch (item.target.name) {
        case 'weaponFlag':
          this.entity.weaponFlag = item.target.checked ? '1' : '0';
          break;
        case 'drugsFlag':
          this.entity.drugFlag = item.target.checked ? '1' : '0';
          break;
        case 'bodilyInjuryFlag':
          this.entity.bodilyInjuryFlag = item.target.checked ? '1' : '0';
          break;
      }
    },
    newDiscipline() {
      return {
        academicYearRank: null,
        disciplineId: 0,
        discActionCode: 0,
        discActionDescription: '',
        discLengthCode: 0,
        discLengthDescription: '',
        disciplineDate: null,
        studentSieId: store.getters['$_student/StudentSie'],
        academicYearId: 0,
        academicYearDescription: '',
        disciplineDescription: '',
        drugFlag: '0',
        weaponFlag: '0',
        bodilyInjuryFlag: '0',
        createDate: new Date(),
        createById: null,
        createByFullName: '',
        modifyDate: new Date(),
        modifyById: null,
        modifyByFullName: '',
        deleteFlag: '0',
        edenReportedDate: null,
        locationSchool_Code: '',
        locationSchool_Id_Pk: 0,
        locationSchool_Name: '',
        district_Id_Pk: 0,
        district_Name: '',
        municipality_Id_Pk: 0,
        municipality_Name: '',
        region_Id_Pk: 0,
        region_Name: '0',
        center_Id_Pk: 0,
        center_Name: '0',
      };
    },
    formatDate(date) {
      return moment(date)
        .locale('es')
        .format('DD/MMM/YYYY');
    },
    formatData(data) {
      return {
        academicYearRank: data.academicYearRank,
        disciplineId: data.disciplineId,
        discActionCode: data.discActionCode,
        discActionDescription: data.discActionDescription,
        discLengthCode: data.discLengthCode,
        discLengthDescription: data.discLengthDescription,
        disciplineDate: moment(data.disciplineDate),
        studentSieId: data.studentSieId,
        academicYearId: data.academicYearId,
        academicYearDescription: data.academicYearDescription,
        disciplineDescription: data.disciplineDescription,
        drugFlag: data.drugFlag,
        weaponFlag: data.weaponFlag,
        bodilyInjuryFlag: data.bodilyInjuryFlag,
        createDate: data.createDate,
        createById: data.createById,
        createByFullName: data.createByFullName,
        modifyDate: data.modifyDate,
        modifyById: data.modifyById,
        modifyByFullName: data.modifyByFullName,
        deleteFlag: data.deleteFlag,
        edenReportedDate:
          data.edenReportedDate !== null ? this.data.edenReportedDate : null,
        locationSchool_Code: data.locationSchool_Code,
        locationSchool_Id_Pk: data.locationSchool_Id_Pk,
        locationSchool_Name: data.locationSchool_Name,
        district_Id_Pk: data.district_Id_Pk,
        district_Name: data.district_Id_Pk,
        municipality_Id_Pk: data.district_Id_Pk,
        municipality_Name: data.district_Id_Pk,
        region_Id_Pk: data.district_Id_Pk,
        region_Name: data.region_Name,
        center_Id_Pk: data.center_Id_Pk,
        center_Name: data.center_Name,
      };
    },
    async save() {
      const isValid = await this.$refs.formAddEditDiscipline.validate();

      if (
        this.selectedAction &&
        this.selectedAction.eduespCodeId === this.code.IAES
      ) {
        this.noneIsChecked =
          this.entity.weaponFlag === '0' &&
          this.entity.drugFlag === '0' &&
          this.entity.bodilyInjuryFlag === '0';
      }

      if (!isValid) return;

      if (this.noneIsChecked) return;

      if (this.canAddStudent && !this.students.length) {
        this.ShowToast(
          'Error',
          'Es requerido al menos un estudiante para poder guardar',
          'error'
        );
        return;
      }

      const data = {
        Id: this.entity.disciplineId,
        StudentSieId: Number(this.entity.studentSieId),
        LocationSchoolId: this.entity.locationSchool_Id_Pk,
        DiscActionCode: this.entity.discActionCode,
        DiscLengthCode: this.entity.discLengthCode,
        AcademicYearId: this.entity.academicYearId,
        BodilyInjuryFlag: this.entity.bodilyInjuryFlag,
        DisciplineDate: this.entity.disciplineDate,
        DisciplineDescription: this.entity.disciplineDescription,
        DrugFlag: this.entity.drugFlag,
        WeaponFlag: this.entity.weaponFlag,
        DeleteFlag: this.entity.deleteFlag,
        EDENReportedDate: this.entity.edenReportedDate,
      };

      if (this.canAddStudent) {
        data.StudentSieId = Number(this.students[0].studentId);
        data.certificationId = this.certificationId;
      }

      this.$ApiPost('api/student/discipline/save', data)
        .then((res) => {
          this.entity = this.formatData(res.data);
          this.ShowToast(
            'Proceso exitoso.',
            'La disciplina fue guardada exitosamente',
            'success'
          );
          this.$emit('discipline', this.entity);
          this.isSaved = true;
        })
        .catch((err) => {
          this.ShowToast('Alerta', err.message, 'error');
        });
    },
  },
};
</script>

<style scoped>
.discipline-container {
  font-weight: 400;
}
</style>
